module.exports = __webpack_public_path__ + "img/car_enabled.02702448.svg";